import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { FruitifyQuestionSearch } from "../../features/question/components/FruitifyQuestionSearch";

export const ChooseExistingQuestionDialog = ({
  open,
  setOpen,
  subject,
  educationLevel,
  onQuestionSelected,
  chosenQuestions,
  quiz = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth={"md"}
      disableScrollLock
      slotProps={{
        paper: {
          component: "form",
          sx: {
            backgroundImage: "none",
            height: "90vh",
            display: "flex",
            flexDirection: "column",
          },
        },
      }}
    >
      <DialogTitle>Select Existing Question</DialogTitle>
      <DialogContent>
        <FruitifyQuestionSearch
          specificSubject={subject}
          specificLevel={educationLevel}
          excludeQuestions={chosenQuestions}
          onQuestionSelected={onQuestionSelected}
          quiz={quiz}
          hideTitle
          assignmentCreate
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} variant={"outlined"}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
